import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { article } from "~/data";
import type { contentLiveTagContent$key } from "~/queries/__generated__/contentLiveTagContent.graphql";

import { LiveTag } from "./styles";

type Props = {
  reference: contentLiveTagContent$key;
};
export const ContentLiveTag: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const content = useFragment(
    graphql`
      fragment contentLiveTagContent on Content {
        ... on Article {
          flattenTypeIds
          tmpLiveArticle {
            status
          }
        }
      }
    `,
    reference_,
  );

  const isLiveArticle = content.flattenTypeIds?.includes(article.types.live.entityUuid);
  const isLive = content.tmpLiveArticle?.status;
  if (!isLiveArticle || !isLive) return null;

  return <LiveTag>LIVE</LiveTag>;
};

ContentLiveTag.displayName = "ContentLiveTag";
